import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {HttpErrorResponse} from "@angular/common/http";
import {delay, takeUntil} from "rxjs/operators";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {FormHelperService} from "../../../../shared/services/form-helper.service";
import {OfwcaService} from "../../../../shared/services/ofwca.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {LeaveApplication} from "../../../../shared/interface/employee";
import {FileBase64} from "../../../../shared/components/file-drag-and-drop/file-drag-and-drop.component";
import {ReplaySubject} from "rxjs";
import {LeaveApplicationService} from "../../../../shared/services/leave-application.service";

export interface LeaveApplicationAddDialogData {
  leaveApplication: LeaveApplication;
}

@Component({
  selector: 'app-leave-application-add-file',
  templateUrl: './leave-application-add-file.component.html',
  styleUrls: ['./leave-application-add-file.component.scss']
})
export class LeaveApplicationAddFileComponent implements OnInit, OnDestroy {

  addFileForm: FormGroup;
  leaveApplicationObject: LeaveApplication;
  processingRequest = false;
  fileContentControl: FormControl;
  fileNameControl: FormControl;
  enableSaveButton = false;
  fileMaxSize = 5242880;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    public dialogRef: MatDialogRef<LeaveApplicationAddFileComponent>,
    @Inject(MAT_DIALOG_DATA) public data: LeaveApplicationAddDialogData,
    private fb: FormBuilder,
    private formHelper: FormHelperService,
    private leaveApplicationService: LeaveApplicationService,
    private snack: MatSnackBar,
  ) {
    this.leaveApplicationObject = data.leaveApplication;
    this.addFileForm = fb.group({
      fileContent: this.fileContentControl = fb.control('', [Validators.required]),
      fileName: this.fileNameControl = fb.control('')
    });
  }

  ngOnInit(): void {
    this.addFileForm.valueChanges
      .pipe(
        delay(0),
        takeUntil(this.destroyed$)
      )
      .subscribe(() => this.enableSaveButton = this.addFileForm.valid);
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  sendForm(): void {
    this.processingRequest = true;

    this.leaveApplicationService.sendFile(this.addFileForm.value, this.leaveApplicationObject.uuid)
      .subscribe(() => {
        this.snack.open('Pomyślnie zaktualizowano obiekt partnera', '', {
          duration: 2000,
        });
        this.processingRequest = false;
        this.dialogRef.close();
      }, (error: HttpErrorResponse) => {
        this.processingRequest = false;
        this.snack.open('Podczas aktualizacji obiektu partnera wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });


      })
    ;
  }
  closeDialog(e): void {
    this.dialogRef.close(e);
  }

  fileSelected($event: FileBase64): void {
    this.fileNameControl.setValue($event?.filename);
    this.fileContentControl.setValue($event?.base64);
  }


}
